export const hasNoPermissionToEdit = (pageName, permissions) => {
    const foundItem = permissions?.[pageName];
    if (!foundItem?.hasEditPermission) {
        return true;
    } else return false;
};
